import React from 'react'
import Navbar from '../components/Navbar';
import Footer from "../components/Footer";
import HeroImg2 from "../components/HeroImg2";
import Form from '../components/Form';
import WhatsAppButton from '../components/WhatsAppButton';

const Contact = () => {
  return (
    <div>
      <Navbar/>
      <HeroImg2 heading="CONTACT." text="Communicate at any time of the day" />
      <Form/>
      <WhatsAppButton />
      <Footer/>
    </div>
  )
}

export default Contact